<template>
  <!-- 首页 -->
  <div class="home">
    <!-- 顶部导航栏 -->
    <TopNav></TopNav>
    <!-- 首页轮播图 -->
    <HomeBanner></HomeBanner>
    <!-- 产品体系 -->
    <System></System>
    <!-- 智能硬件系统 -->
    <Hardware></Hardware>
    <!-- 丰富的软件设备 -->
    <Software></Software>
    <!-- 我们服务的客户 -->
    <Customer></Customer>
    <!-- 最新资讯 -->
    <Dynamic></Dynamic>

    <div class="logo-position">
      <img class="mobileexperienceLogo" :src="mobileexperienceLogo" alt="" />
      <div class="logo-absolute">
        <div class="text">
          畅月数字家园致力于移动互联网、物联网、智能设备、云计算等新技术,建立开放生态技术平台，持续提升智慧社区服务效率，建立智慧社区,实现管理透明化、服务智能化、决策数据化、平台生态化、流程工具化，让客户更满意，让员工更愉悦......
        </div>
        <div class="click" @click="experienceClick">立即体验</div>
      </div>
    </div>

    <div class="header">
      <div class="title">一站式服务</div>
      <div class="border"></div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNav></BottomNav>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/mobile/components/TopNav.vue";
import BottomNav from "../../../components/mobile/components/BottomNav.vue";
import HomeBanner from "../../../components/mobile/Home/HomeBanner.vue";
import System from "../../../components/mobile/Home/System.vue";
import Hardware from "../../../components/mobile/Home/Hardware.vue";
import Software from "../../../components/mobile/Home/Software.vue";
import Customer from "../../../components/mobile/Home/Customer.vue";
import Dynamic from "../../../components/mobile/Home/Dynamic.vue";
import Experience from "../../../components/mobile/components/Experience.vue";

import mobileexperienceLogo from "../../../assets/home/mobileexperienceLogo.png";

export default {
  setup() {
    return reactive({
      mobileexperienceLogo: mobileexperienceLogo,
      experienceShow: false,
    });
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
  components: {
    TopNav,
    BottomNav,
    HomeBanner,
    System,
    Hardware,
    Software,
    Customer,
    Dynamic,
    Experience,
  },
};
</script>

<style scoped>
.header {
  background: rgba(243, 244, 248, 0.4);
  margin-top: 24px;
  padding-top: 16px;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}

.logo-position {
  position: relative;
}
.mobileexperienceLogo {
  width: 100%;
  height: 128px;
}
.logo-absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
}
.logo-absolute .text {
  font-size: 10px;
  color: #fff;
}
.logo-absolute .click {
  margin-top: 12px;
  border: 1px solid #ffffff;
  color: #fff;
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
